import { useLang } from "@/i18n";

const STATS = [
  { value: "₹1,200 Cr+", key: "proof.s1" },
  { value: "47", key: "proof.s2" },
  { value: "12", key: "proof.s3" },
  { value: "38,000+", key: "proof.s4" },
];

export const ProofStrip = () => {
  const { t } = useLang();
  return (
    <section data-testid="proof-strip" className="border-y border-[#1A2A24]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#1A2A24] border-x border-[#1A2A24]">
          {STATS.map((s, i) => (
            <div
              key={s.key}
              data-testid={`proof-stat-${i}`}
              className="bg-[#0E1613] py-10 md:py-14 px-5 md:px-8"
            >
              <div className="font-display text-3xl md:text-4xl text-[#EDE7DA] tracking-tight">
                {s.value}
              </div>
              <div className="font-mono-label text-[9px] md:text-[10px] tracking-[0.22em] uppercase text-[#EDE7DA]/50 mt-3">
                {t(s.key)}
              </div>
            </div>
          ))}
        </div>
        <p className="font-mono-label text-[10px] tracking-[0.18em] uppercase text-[#5E8570] py-6">
          {t("proof.note")}
        </p>
      </div>
    </section>
  );
};
